module.exports = __webpack_public_path__ + "static/media/editor-light.517bf010.svg";